export default "__VITE_ASSET__DMOOz07c__"